// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"a8af03d0","119":"ec2c9a22","126":"8cb6b4f1","370":"6c06660d","501":"48d7aaf6","521":"5ea2d005","634":"e321b1a6","787":"a78a7ac1","849":"35373913","884":"a6bdb4db","919":"28b0c2af"}[chunkId] + ".chunk.js";
};